// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2HWAY","title":"InfoRow_title__3eqPj"};